import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import aeLogo  from "../../Assets/tool/ae.png";
import prLogo  from "../../Assets/tool/pr.png";
import auLogo  from "../../Assets/tool/au.png";
import meLogo  from "../../Assets/tool/me.png";
import psLogo  from "../../Assets/tool/ps.png";
import lrcLogo from "../../Assets/tool/lrc.png";
import aiLogo  from "../../Assets/tool/ai.png";
import dLogo   from "../../Assets/tool/d.png";
import jLogo   from "../../Assets/tool/f.png";
import fLogo   from "../../Assets/tool/j.png";

import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  const tools = [
    { src: aeLogo, alt: "Adobe After Effects" },
    { src: prLogo, alt: "Adobe Premiere Pro" },
    { src: auLogo, alt: "Adobe Audition" },
    { src: meLogo, alt: "Adobe Media Encoder" },
    { src: psLogo, alt: "Adobe Photoshop" },
    { src: aiLogo, alt: "Adobe Illustrator" },
    { src: lrcLogo, alt: "Adobe Lightroom Classic" },
    { src: dLogo, alt: "DaVinci Resolve" },
    { src: jLogo, alt: "Final Cut Pro" },
    { src: fLogo, alt: "剪映" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, index) => (
        <Col xs={4} md={2} className="tech-icons" key={index}>
          <img
            src={tool.src}
            alt={tool.alt}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />
          <p style={{ marginTop: "8px", fontSize: "18px", color: "#ccc" }}>
           {tool.alt}
          </p>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
